import React, { useState } from 'react';
import styled from 'styled-components';

const AboutCom = () => {
    const [selectedInterest, setSelectedInterest] = useState('');

    const interests = [{
        name: 'Football',
        description: 'About football. From my childhood I am a fan of one football team that is stucked into my heart. Blaugrana in other words Barcelona. The way they play, atmosphere, passion, fans, players, emotions, and history is the best. Whatever may happen but my passion about this cannot be changed. And my personal favourite player is of course Leonel Andres Messi. I don\'s have to explain why.'
    }, {
        name: 'Gym',
        description: 'In late 2022 I started to workout at home at night for a month probably. Then my older cousin noticed that and he invited my to train with him. And now, I am training since then. Back then I was very skinny for my height and gym helped me to gain 20-30 kg\'s. My weight increased and decreased over the seasons. My maximum weight was around 87-85 kg\'s and now I am between 75-79 kg\'s but I know it is not enough for me and I am not satisfied with my physique yet but I know it is coming soon. I need to just keep going. No one spawned at the top of the mountain.'
    }, {
        name: 'History',
        description: 'From my young ages I had an interest in history. At that time I\'ve watched thousands of TV shows about history and I am pretty sure I know something. Especially I interested in ancient Greek civilization due to it\'s mythology and movies. Then I started to like the history of two world wars, I do not know why... Apart from that I like the history of the scandinavians, ancient Egypt and a lot of other periods of time.'
    }, {
        name: 'Movies',
        description: 'Movies, I am so thankful that I had access to the TV. From Russian TV channels I learned so many thing from a language to the space. Especially, movies. I can count thousands of movies that I like but it would be too many. But i can mention my top actors. Jackie Chan, Brad Pitt, Leonardo Dicaprio, Will Smith, Morgan Freeman, Harrison Ford, Jhonny Depp, Robin Williams, Antonio Banderras, Arnold Schwarzenegger, Ryan Gosling(me), Ryan Reynolds, Dwayne Jhonson, Sylvester Stallone, Dolph Lundgren, Jason Statham, Vin Diesel, Paul Walker and many others.'
    }, {
        name: 'Music',
        description: 'Last years I started to actively listen to music. It is like a therapy for me. It keeps my mind focused. While writing this I am also listening to music. What about my taste in music. My taste in music is like mixed genres. I do not have a favourite genre but most of them is hip-hop music. I don’t know why but I can listen to the music if it has good meaning, lyrics or if it gives good vibe. Here is my Spotify account if you’re interested: https://open.spotify.com/user/31haep3xfe5zetnrx7n7pw5gb75q?si=2189a6529cfe4b44.'
    }, {
        name: 'Cars',
        description: 'Cars. Cars is one of the most intoxicating, most beautiful things ever forged by mankind. Cars were basically the same but this really isn’t. They pushed the boundaries of what we call fast. I would say they are the fastest cars ever made. I won’t. They will be faster one day very soon. But for now, just enjoy the glorious state of the art. It is the words of a famous car journalist Jeremy Clarkson. He with his two mates filmed the show called "Top Gear". In my opinion it is the most successful shows of ever. From this show, from other movies such "Fast and furious " and racing games that I played back then. I can say that these components created interest in cars. Like every man I just interested in basic things. I would say it is mandatory for a man. To be more specific. My favourite car brand is an Italian car brand called Lamborghini. I know that you would think that is overrated but it is not. My favourite model from this brand is  Gallardo LP 550-2 and Murcielago. Apart from that I like Japanese and muscle cars.'
    }, {
        name: 'Games',
        description: 'Games. To be honest I am not a gamer. When I was 5 y.o I started to play racing games on my ancient computer. At that time it was the best period of my life. Apart from that I had a PSP controller when I was 8 y.o and it was interesting too. I am not going to mention all the games that I played because it will take a long time.'
    }];

    const handleInterestClick = (interest) => {
        setSelectedInterest(interest === selectedInterest ? '' : interest);
    };

    return (
        <Container>
            <Header>About Me</Header>
            <InterestsContainer>
                {interests.map((interest, index) => (
                    <Interest key={index} active={interest.name === selectedInterest} onClick={() => handleInterestClick(interest.name)}>
                        {interest.name}
                    </Interest>
                ))}
            </InterestsContainer>
            {selectedInterest && (
                <InterestDetails>
                    <InterestName>{selectedInterest}</InterestName>
                    <InterestDescription>{interests.find(interest => interest.name === selectedInterest).description}</InterestDescription>
                </InterestDetails>
            )}
        </Container>
    );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: black;
  color: #03ff2c;
  padding: 20px;
`;

const Header = styled.h1`
  font-size: 3em;
  font-family: Consolas, monospace;
  margin-bottom: 20px;
  color: #03ff2c;
`;

const InterestsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
`;

const Interest = styled.button`
  font-size: 1.2em;
  padding: 10px 20px;
  border: 2px solid #03ff2c;
  border-radius: 8px;
  background-color: ${props => props.active ? '#03ff2c' : 'black'};
  color: ${props => props.active ? 'black' : '#03ff2c'};
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
  font-family: Consolas, monospace;

  &:hover {
    background-color: #03ff2c;
    color: black;
  }
`;

const InterestDetails = styled.div`
  margin-top: 20px;
  text-align: left;
`;

const InterestName = styled.h2`
  font-size: 2em;
  font-family: Consolas, monospace;
`;

const InterestDescription = styled.p`
  font-size: 1em;
  font-family: Consolas, monospace;
`;

export default AboutCom;
